import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/src/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/src/layouts/empty.vue").then(m => m.default || m))
}